import { render } from "./InputPhoneComponent.vue?vue&type=template&id=44f4bba4&ts=true"
import script from "./InputPhoneComponent.vue?vue&type=script&lang=ts"
export * from "./InputPhoneComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__